export default __webpack_public_path__ + "static/media/landscape15.a812c416.jpeg";